<template>
  <v-app colo="transparent">
    <main-navbar></main-navbar>
    <v-content id="content" color="transparent">
      <router-view />
      <!-- <router-view name="popover"></router-view> -->
    </v-content>
    <messages></messages>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
  mounted() {
    console.log("route", this.$router);
  },
};
</script>
